import "../components/global.js";
import "../assets/css/bootstrap.css";
import Navbar from "../components/Navbar.js";
import { tokens, success, alert, POST, getStorage, loading } from "../components/CustomComponent.js";
import React, { Component } from "react";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";
import excel_file from "../assets/files/import_customer.xlsx";

const STATUS_MAP = { 1: "โอนกรรมสิทธิ์แล้ว", 2: "ยังไม่โอนกรรมสิทธิ์", 3: "ห้องว่าง" };
const BUY_MAP = { 1: "เงินสด", 2: "ผ่อนชำระกับธนาคาร", 3: "ผู้เช่าซื้อกับการเคหะแห่งชาติ", 4: "ซื้อต่อกับลูกค้าเดิม", 5: "อื่น ๆ" };

export default class Import extends Component {
  state = {
    import: null, currentSheet: null, over: false, data_import: null, type: "",
  };

  componentDidMount() {
    loading(false); // ปิด Loading ทันทีที่เข้าหน้าแรก
  }

  Create_Import = async () => {
    loading(true);
    let result = await POST(tokens, `v1/TH/customer-manage/create/${getStorage("project_id")}`, { customer_list: this.state.data_import });
    if (result?.status) {
      this.setState({ data_import: null });
      success();
    }
    loading(false);
  };

  handleFile = (file) => {
    readFile(file).then((readedData) => {
      if (readedData.SheetNames[0] === "ประวัติการชำระเงิน") {
        this.setState({ import: readedData }, () => setTimeout(this.Import, 10));
      } else alert("info", "แจ้งเตือน", "ไฟล์ไม่ถูกต้อง");
    }).catch(console.error);
  };

  Import_file = (e) => {
    if (e.target.files[0]) this.handleFile(e.target.files[0]);
    e.target.value = "";
  };

  drop_file = (e) => {
    e.preventDefault();
    this.setState({ over: false });
    const file = e.dataTransfer.items[0]?.getAsFile();
    if (file) this.handleFile(file);
  };

  Import = () => {
    const data = generateObjects(this.state.currentSheet)
      .filter((item) => item["บ้านเลขที่"] !== "")
      .map((item) => ({
        address_number: item["บ้านเลขที่"], full_name: item["ชื่อ-นามสกุล"], date_of_note: item["วันที่จด"],
        current_gauge_number: item["เลขมาตรเดือนนี้"], last_gauge_number: item["เลขมาตรเดือนก่อน"],
        unit_used: item["หน่วยที่ใช้"], water_bill: 0, equipment_maintenance_fee: 0, common_expenses: 0,
        waste_cost: 0, cable_cost: 0, other_income: item["รายได้อื่น ๆ"], add_debt: item["เพิ่มหนี้"],
        reduce_debt: item["ลดหนี้"], remark_add_debt: item["หมายเหตุเพิ่มหนี้"], remark_reduce_debt: item["หมายเหตุลดหนี้"],
        total_amount: 0, room_size: 0, status_meter: 0, setting_water_id: getStorage("water_id"),
        water_charge_start: 0, water_charge_end: 0, water_charge_price: 0, water_rate_list: [],
      }));
      
    if (data.length > 0) data.shift(); // ข้ามแถวตัวอย่างข้อมูล
    this.setState({ data_import: data });
  };

  render() {
    const s = this.state;
    const tdL = (val) => <td className={val ? "text-left" : "text-left bg-danger-light"}>{val || "-"}</td>;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายชื่อลูกค้า" />
        <div className="body">
          <div className="p-3">
            <div className="w-100 d-flex justify-content-between mb-3">
              <h4 className="mb-3"><b>นำเข้าไฟล์ข้อมูล : ประวัติการชำระเงิน</b></h4>
              <div className="d-flex">
                <button className="btn btn-outline-primary wpx-150 mx-1" onClick={() => window.location.href = "/import"}><span className="icon-brand mr-2">{"\uf060"}</span>ย้อนกลับ</button>
                {s.data_import && <button className="btn btn-danger wpx-150 mx-1" onClick={() => this.setState({ data_import: null })}>ล้างค่า</button>}
                {s.data_import && <button className="btn btn-primary wpx-150 mx-1" onClick={this.Create_Import}>นำเข้า</button>}
              </div>
            </div>

            {!s.data_import ? (
              <div className="card border-0 p-3 mb-3">
                <div className="w-100 text-right">
                  <a className="text-primary mt-3" href={excel_file} download="import_customer.xlsx"><label className="icon">{"\uf65b"}</label> template นำเข้าข้อมูลประวัติการชำระเงิน</a>
                </div>
                <div className={`card py-5 border-dashed align-items-center ${s.over ? "bg-blue-sky" : "bg-light"}`}
                  onDrop={this.drop_file} onDragOver={(e) => { e.preventDefault(); this.setState({ over: true }); }} onDragLeave={(e) => { e.preventDefault(); this.setState({ over: false }); }}>
                  <b className="icon text-primary mt-4" style={{ fontSize: 48 }}>{"\uf56f"}</b>
                  <b className="text-secondary">ลากและวางไฟล์ที่นี่</b>
                  <small className="text-secondary mb-3">หรือ</small>
                  <button className="btn btn-primary wpx-120 mb-4" onClick={() => document.getElementById("file").click()}>เลือกไฟล์</button>
                  <input className="d-none" type="file" id="file" accept=".xls,.xlsx" onChange={this.Import_file} />
                </div>
              </div>
            ) : (
              <div className="card border-0 mb-3">
                <div className="card-header bg-dark-blue px-3 rounded-top"><h4 className="text-white mb-0"><b>ข้อมูลนำเข้า</b></h4></div>
                <div className="p-3">
                  <div className="table-responsive">
                    <table className="table table-borderless table-striped">
                      <thead>
                        <tr className="bg-dark-blue text-white">
                          <th>ชื่อ - สกุล</th><th>เลขบัตรประชาชน</th><th>ที่อยู่</th><th>โทรศัพท์บ้าน</th><th>โทรศัพท์มือถือ</th>
                          <th>วันที่ส่งมอบ</th><th>วันที่มารับมอบ</th><th>วันที่โอน</th><th>สถานะการโอน</th><th>เลขที่เงินกู้</th>
                          <th>วงเงินกู้</th><th>เงินงวด</th><th>วันที่ทำสัญญา</th><th>ซื้ออาคารโดย</th><th>อาคาร</th>
                          <th>ชั้น</th><th>บ้านเลขที่</th><th>ขนาดห้อง (ตรม.)</th><th>ลบ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {s.data_import.map((item, index) => (
                          <tr key={index}>
                            {tdL(item.full_name)}
                            {tdL(item.id_card)}
                            {tdL(item.address)}
                            <td className="text-left">{item.home_phone || "-"}</td>
                            {tdL(item.mobile_phone)}
                            <td className="text-left">{item.delivery_date || "-"}</td>
                            <td className="text-left">{item.receive_date || "-"}</td>
                            <td className="text-left">{item.transfer_date || "-"}</td>
                            {tdL(item.status_transfer ? STATUS_MAP[item.status_transfer] || "-" : null)}
                            <td className="text-left">{item.loan_number || "-"}</td>
                            <td className="text-left">{item.credit_limit || "-"}</td>
                            <td className="text-left">{item.installment || "-"}</td>
                            <td className="text-left">{item.contract_date || "-"}</td>
                            {tdL(item.status_buy_building ? BUY_MAP[item.status_buy_building] || "-" : null)}
                            {tdL(item.address_number)}
                            {tdL(item.building)}
                            {tdL(item.floor)}
                            {tdL(item.room_size)}
                            <td>
                              <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center">
                                <label className="icon mx-2 text-danger pointer" onClick={() => {
                                  let dt = [...s.data_import]; dt.splice(index, 1);
                                  this.setState({ data_import: dt.length ? dt : null });
                                }}>{"\uf2ed"}</label>
                              </label>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            <div className="d-none">
              <ReactExcel initialData={s.import} onSheetUpdate={(sheet) => this.setState({ currentSheet: sheet })} activeSheetClassName="d-none" reactExcelClassName="table table-borderless table-striped" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}